import { render } from "./form-inputs.vue?vue&type=template&id=2dfdac8a&lang=pug"
import script from "./form-inputs.vue?vue&type=script&setup=true&lang=js"
export * from "./form-inputs.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__